import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { trackingTypes, trackingActions } from '../../../constants';
import Trackable from '../../../components/trackable';
import { Link } from '@hub/link';
import { Box } from '@hub/box';
import { useToken } from '@hub/design-system-base';
import { H5 } from '@hub/heading';
import { CloudinaryImage } from '../../cloudinary-image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      paddingTop: 'spacing-sm',
      flex: '1 1'
    },
    "data-test-id": "spotlight-detail",
    "data-id": "spotlight-card_index_Title_Box",
    children: /*#__PURE__*/_jsx(H5, {
      fontSize: ['font-h5-mobile', null, 'font-h5'],
      "data-id": "spotlight-card_index_Title_Box_H5",
      children: title
    })
  });
};
const SpotlightCard = _ref2 => {
  let {
    imageUrl,
    link,
    title,
    onClick,
    analyticsMetadata
  } = _ref2;
  const color = useToken('color', 'textPrimary');
  const background = useToken('color', 'surfaceBrandPrimary');
  return /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({}, analyticsMetadata), {}, {
    trackingAction: trackingActions.viewPromotion,
    type: trackingTypes.promotion,
    "data-id": "spotlight-card_index_Title_Trackable",
    children: /*#__PURE__*/_jsxs(Link, {
      href: link,
      onClick: onClick,
      sx: {
        textDecoration: 'none',
        color
      },
      "data-id": "spotlight-card_index_Title_Trackable_Link",
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          background,
          padding: 'spacing-2xl'
        },
        "data-id": "spotlight-card_index_Title_Link_Box",
        children: /*#__PURE__*/_jsx(CloudinaryImage, {
          ratio: 1,
          imageSetOrImage: {
            url: imageUrl,
            alt: title,
            type: 'SQUARE'
          },
          imageFormat: "none",
          "data-id": "spotlight-card_index_Title_Box_CloudinaryImage"
        })
      }), /*#__PURE__*/_jsx(Title, {
        title: title,
        "data-id": "spotlight-card_index_Link_Title"
      })]
    })
  }));
};
export default SpotlightCard;